import { atom } from "recoil";

export const getTodayDateString = (): string => {
	const today = new Date();
	const year = today.getFullYear();
	const month = String(today.getMonth() + 1).padStart(2, '0');
	const day = String(today.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
};

export const DEFAULT_FROM_DATE = '2026-01-01';

function getInitialFilters() {
	const params = new URLSearchParams(window.location.search);

	return {
		productType: params.get("productType") || "All",
		member: params.get("member") ? parseInt(params.get("member")!) : "",
		// Default to 1 Jan 2026 instead of current year start
		fromDate: params.get("fromDate") ? new Date(params.get("fromDate")!) : new Date(2026, 0, 1),
		toDate: params.get("toDate") ? new Date(params.get("toDate")!) : new Date(),
	};
}

export const filtersAtom = atom({
	key: "filters",
	default: getInitialFilters(),
});

export const transactionClaimAtom = atom<{
	claimId: string | null;
	transactionId: string | null;
} | null>({
	key: 'transactionClaimAtom',
	default: null,
});

// ── ⭐ NEW: Persists ClaimsTable filters across route navigation ──
export const claimsFilterAtom = atom({
	key: "claimsFilter",
	default: {
		searchText: "",
		statusFilter: "ALL" as string,
		vendorFilter: "ALL" as string,
		fromDate: DEFAULT_FROM_DATE,
		toDate: getTodayDateString(),
	},
});